import { Request } from '~src/httpClient/serverApi/requests/Request';

import { IContentRelayPlanDetail } from '../types/ISelectionQuery';

/**
 * Parameters for the VizPortal `getPlan` Web Client method
 * (WebClientContentMobilityAppService.getPlan). Used to read a plan's current `selectionQueries`
 * before an "add to existing plan" update (which replaces the selection wholesale).
 */
export interface IGetContentRelayPlanParams {
  luid: string;
}

export class GetContentRelayPlanRequest extends Request<IGetContentRelayPlanParams, IContentRelayPlanDetail> {
  constructor(params: IGetContentRelayPlanParams) {
    super('getPlan', params);
  }
}
